export default function formAPIFollowups({
    followupid,
    doctorid,
    isfollowup,
    followupdate,
    isfreevisit,
    isfreevisitbooked,
    appointmentid,
    doctorimage,
    patientname,
    patientfcmtoken,
    patientmobile,
    patientemail,
    specality,
    doctorname,
    imagepath,
    referredby,
    isdoctoractive,
    patientid,
    followupcount
    
  }) {
   
  
    return Object.freeze({
        followupid,
    doctorid,
    isfollowup,
    followupdate,
    isfreevisit,
    isfreevisitbooked,
    appointmentid,
    doctorimage,
    patientname,
    patientfcmtoken,
    patientmobile,
    patientemail,
    specality,
    doctorname,
    imagepath,
    referredby,
    isdoctoractive,
    patientid,
    followupcount
    });
  }
  